<template>
  <v-row class="pt-10" justify="space-around" no-gutters>
    <v-col v-for="(item, i) in value" :key="i"
           class="pa-2 d-flex align-center justify-center cer-wrapper">
      <div class="white rounded-circle cer-img overflow-hidden d-flex align-center justify-center">
        <v-img :src="item.icon" alt="" aspect-ratio="1"/>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "certificatesView",

  props: {
    value: Array
  }
}
</script>

<style scoped>
.cer-wrapper {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}

.cer-img {
  width: 100%;
  height: 74px;
  min-height: 74px;
  max-width: 74px;
}
</style>